/// <amd-module name="Repos/VersionDropdown/Components/VersionDropdownAsTextField" />
import * as React from "react";
import { VersionDropdown, VersionDropdownExpandableTextField } from "./VersionDropdown";
import { IVersionDropdownProps } from "./VersionDropdown.Props";
import { Components } from "VSS/Platform/Layout";

export const VersionDropdownAsTextField: React.FunctionComponent<IVersionDropdownProps> = props => {
    return (
        <VersionDropdown
            {...props}
            renderExpandable={VersionDropdownExpandableTextField}
        />
    )
}

Components.add("ms.vss-code-web.version-dropdown-as-textfield", VersionDropdownAsTextField);
